import { render, staticRenderFns } from "./auditRecord.vue?vue&type=template&id=416ca637&scoped=true"
import script from "./auditRecord.vue?vue&type=script&lang=js"
export * from "./auditRecord.vue?vue&type=script&lang=js"
import style0 from "./auditRecord.vue?vue&type=style&index=0&id=416ca637&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416ca637",
  null
  
)

export default component.exports